import styled from "styled-components/macro";

export const CopyableTextAreaContainer = styled.div`
  background: var(--simplified-sb-background);
  border-radius: 20px;
  box-shadow: none;
  margin-bottom: 0px;
  position: relative;
  padding: 6px;

  // &.story-bible {
  //   background-color: var(--menu-color);
  // }

  .textarea-container {
    padding: 0 10px 10px 10px;
    textarea {
      padding-bottom: 32px;
      font-size: 16px !important;
      font-weight: 400;
      font-style: normal;
      line-height: 1.3;
    }

    textarea:focus {
      border: 1px solid var(--primary-cta-high-contrast);
    }

    textarea.meta-field-diff {
      color: var(--primary-cta-high-contrast);
    }
  }


  .feedback-container-scenes {
    .textarea-info {
      bottom: 18px;
      right: 10px;
    }
  }

  .feedback-container {
    position: relative;

    .like-container {
      position: absolute;
      bottom: ${(props) => (props.$textAreaFocused ? "34px" : "-10px")};
      right: 3px;
      z-index: 2;
    }

    &#textarea-container-commands {
      padding-bottom: 2px;

      &.feedback-container-scenes {
        padding-bottom: 8px;
      }
    }
  }

  .bottom-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .bottom-bar-info {
      color: var(--grey-1);
      font-weight: 500;
      line-height: 1.2em !important;
      margin-top: 8px;
    }
    .bottom-bar-prose-generator {
      flex-basis: 100%;
      padding-top: 7px;
      position: relative;

      &:before {
        content: "";
        border-top: 2px solid var(--divider);
        width: calc(100% + 40px);
        position: absolute;
        left: -20px;
        top: 0px;
      }
      .inner {
        padding-top: 10px;
        display: flex;
        justify-content: space-between;
        flex-basis: 100%;
        align-items: center;

        .left {
          display: flex;
          flex-direction: column;

          .title {
            font-size: 16px;
            font-weight: 500;
            color: var(--grey-0);
          }

          .title-large {
            font-size: 18px;
            font-weight: 500;
          }
        }
      }
    }
    .info-hidden {
      display: none;
    }
    .small-info {
      padding-right: 0;
      padding-left: 0;
    }
  }

  .rewrite-container {
    padding: 0 10px 10px 10px;
  }
  .rewrite-form {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    min-height: 95px;
    gap: 10px;
    button {
      margin-top: 0px !important;
      transform: translateX(-11px);
      border-radius: 10px !important;
      height: 39px !important;
    }
    border: 1px solid var(--grey-3);
    box-shadow: var(--tiny-drop-shadow);
    border-radius: 5px;
    padding: 12px;
    margin-top: 10px;
    background-color: var(--document-background);

    div:first-child {
      width: 87%;
    }

    textarea {
      border: 0px;
      padding: 0px 12px 0px 0px;
      border-radius: 0px;
      background-color: transparent !important;
      font-size: 16px !important;
      font-style: normal;
      font-weight: 400;
      line-height: 1.3;
      box-shadow: none;
      .short {
        margin-top: 0px !important;
        padding: 0px;
      }
    }

    &:focus-within {
      border: 1px solid var(--primary-cta);
    }
  }

  .rewrite-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 8px;
    padding-top: 18px;
    h2 {
      margin-bottom: 0px !important;
      font-weight: 500;
      line-height: 0;
    }
  }

  .outline-template-link {
    color: var(--grey-1);
    position: absolute;
    bottom: 42px;
    left: 18px;
    text-decoration: underline;
  }

  .shortcut-icon {
    path {
      fill: var(--cta-text-color) !important;
      stroke: none;
    }
  }
`;
